import { styled } from 'styled-components';

import _getGames from '@src/io/events_out/_getGames';
import icon from '@src/asset/img/filter.png';

import useSound from 'use-sound';
import lobbyRefresh from '@src/asset/sound/lobbyRefresh.wav';

const Button = styled.img<{ filtered: number }>`
  height: 2.7rem;
  width: 2.7rem;

  cursor: pointer;
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;

  // set opacity if filtered
  ${(props) =>
    props.filtered &&
    `
    opacity: 0.5;
  `}

  @media only screen and (max-width: 720px) {
    width: 2rem;
    height: 2rem;
  }
`;

type Props = {
  onClick: () => void;
  filtered: boolean;
};

export default function FilterTourneyButton(props: Props) {
  const [playSound] = useSound(lobbyRefresh, { volume: 0.25 });

  const onClick = () => {
    playSound();
    props.onClick();
  };
  return (
    <Button
      src={icon}
      onClick={onClick}
      title='refresh'
      filtered={props.filtered ? 1 : 0}
    />
  );
}
